const detail = {
  path: 'detail/:noticeId',
  component: resolve => require(['../../../../../pages/user/course/importantnotice/detail'], resolve)
}

export default detail



// WEBPACK FOOTER //
// ./src/router/user/course/importantnotice/detail/index.js